import React from 'react';
import PropTypes from 'prop-types';

const ToggleButton = ({
  id = 'switch button',
  height = undefined,
  width = undefined,
  isOn = false,
  onClick = () => {},
  label = undefined,
  labelClassNames = 'text-sm font-normal',
}) => {
  return (
    <div className="flex gap-3 items-center">
      <label htmlFor={id} className={labelClassNames}>{label}</label>
      <button
        type="button"
        role="switch"
        aria-checked={isOn}
        aria-label={`Toggle ${isOn ? 'on' : 'off'}`}
        onClick={onClick}
        id={id}
        className={`${width || 'w-16.5'} 
    ${height || 'h-7.5'} relative`}
      >
        <div className={`${width || 'w-16.5'} ${height || 'h-7.5'} left-0 top-0 absolute ${isOn ? 'bg-vamos-green1' : 'bg-vamos-gray'} rounded-20px`} />
        {/* toggle button */}
        <div aria-hidden="true" className={`w-5.5 h-5.5 ${isOn ? 'right-1' : 'left-1'} top-1 absolute bg-vamos-white rounded-xl`} />
        <div aria-hidden="true" className={`${isOn ? 'pl-2' : 'pl-8'} top-1.5 absolute text-vamos-white text-sm font-bold`}>
          {`${isOn ? 'ON' : 'OFF'}`}
        </div>
      </button>
    </div>
  );
};

ToggleButton.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  isOn: PropTypes.bool,
  onClick: PropTypes.func,
  id: PropTypes.string,
  label: PropTypes.string,
  labelClassNames: PropTypes.string,
};

export default ToggleButton;
